import Maps from "./ClassMaps"


const map = document.querySelector('#mapReports')

if (map) {
    const lng = map.getAttribute('data-long')
    const lat = map.getAttribute('data-lat')
    const zoom = map.getAttribute('data-zoom')


    /*From URL*/
    let urlQuery = window.location.search
    let params = new URLSearchParams(urlQuery)
    let urlQueryPost = params.get("reportID")
    let urlQueryTerm = params.get("reports_category")
    let urlQueryPreview = params.get("preview")
    let urlQueryPrivate = params.get("private")
    let urlQueryCategory = params.get("category")
    let urlQuerySubcategories = params.get("subCategories")
    let urlQueryKeyword = params.get("keyword")
    let urlQueryStatus = params.get("status")

    // Filters
    const categoryFilters = document.querySelector('#categoryFilter')
    const subCategoryFilters = document.querySelector('#subCategorieList')
    const keywordsFilter = document.querySelector('#keywordsFilter')
    const statusFilterContainer = document.querySelector('#reportStatus')
    const statusFilter = document.querySelector('#statusInput')
    const filterBTN = document.getElementById('validateSystemeFilter')
    const resetBTN = document.getElementById('resetSystemeFilter')
    let open = false

    // Init the Maps Class
    const Map = new Maps(lng, lat, zoom)

    // Init the PostsQuery Class
    new PostsQuery()

    // Init the Map
    Map.init


    // Get base query params
    if (urlQueryPreview === 'true') {
        Map.mapParams.isPreview = true
    }

    const body = document.querySelector('body')
    if(body.classList.contains('logged-in') && (urlQueryPrivate === 'true')) {
        Map.mapParams.isPrivate = true
    }

    if(urlQueryTerm){
        Map.mapParams.category = urlQueryTerm
    }

    if(urlQueryPost){
        open = true
        Map.mapParams.reportID = urlQueryPost
    }

    if(urlQueryCategory){
        Map.mapParams.category = urlQueryCategory
    }

    if(urlQuerySubcategories){
        Map.mapParams.subCategories = urlQuerySubcategories
    }

    if(urlQueryKeyword){
        Map.mapParams.keyword = urlQueryKeyword
    }

    if(urlQueryStatus){
        Map.mapParams.status = urlQueryStatus
    }


    // Init markers
    Map.addMarkers(open)


    !!filterBTN &&
    filterBTN.addEventListener('click', function () {
        let selectedSubCategoriesID = []
        let selectedCustomFilters = []
        let selectedKeyword = ''
        let selectedStatus = ''
        let selectedCategory = ''

        if (!!categoryFilters) {
            let selectedCategory = categoryFilters.querySelector('input[type="radio"]:checked')
            if (selectedCategory) {
                Map.mapParams.category = selectedCategory.dataset.id
            } else {
                delete Map.mapParams.category
            }
        }

        if (!!subCategoryFilters) {
            let selectedSubCategories = subCategoryFilters.querySelectorAll('input[type="checkbox"]:checked')
            selectedSubCategories.forEach((category) => {
                selectedSubCategoriesID.push(category.value)
            })

            if (selectedSubCategoriesID.length > 0) {
                Map.mapParams.subCategories = selectedSubCategoriesID.toString()
            } else {
                delete Map.mapParams.subCategories
            }
        }
        /*
        let customParams = []
        if (!!$customFilters) {
            $customFilters.forEach(function($customFilter){
                let customFilterCheckboxes = $customFilter.querySelectorAll('input[type="checkbox"]:checked')
                let param = $customFilter.closest('.filter_custom').querySelector('.filter__input-container input').getAttribute('id')
                selectedCustomFilters[param] = []

                customParams.push($customFilter.closest('.filter_custom').querySelector('.filter__input-container input').getAttribute('id'))
                customFilterCheckboxes.forEach((option) => {
                    selectedCustomFilters[param].push(option.value)
                })

                if (customFilterCheckboxes.length > 0) {
                    Query.URLArgs[param] = {}
                    Query.URLArgs[param].parameterValue = selectedCustomFilters[param]
                } else {
                    delete Query.URLArgs[param]
                }
            })
        }
        */


        // Init the Query.URLArgs object with the keyword entry
        if (!!keywordsFilter) {
            selectedKeyword = keywordsFilter.value
            if (selectedKeyword.length > 0) {
                Map.mapParams.keyword = selectedKeyword
            } else {
                delete Map.mapParams.keyword
            }
        }


        if (!!statusFilter) {
            selectedStatus = statusFilterContainer.querySelector('[type=radio]:checked')
            if (selectedStatus) {
                Map.mapParams.status = selectedStatus.value
            } else {
                delete Map.mapParams.status
            }
        }
        /*
        if(customParams.length > 0){
            customParams.forEach(function(customParam){
                params[customParam] = selectedCustomFilters[customParam] ?? ''

                if (Query.URLArgs[customParam]) {
                    params[customParam] = Query.URLArgs[customParam].parameterValue
                }
            })
        }
        */


        Map.addMarkers()
    })

    !!resetBTN &&
    resetBTN.addEventListener('click', function(){
        delete Map.mapParams.category
        delete Map.mapParams.subCategories
        delete Map.mapParams.keyword
        delete Map.mapParams.status
        Map.addMarkers()
    })

    function requireAll(r) {
        r.keys().forEach(r);
    }

    requireAll(require.context('../../', true, /\.(png|jpe?g|gif|svg)$/));

}


